import { gql } from 'graphql-request'

export const TOGGLE_IS_STOP_SAP_PAYMENT = gql`
  mutation ToggleIsStopSapPayment($userId: Int!) {
    toggleIsStopSapPayment(userId: $userId) {
      id
    }
  }
`
